import React from "react";
import LoginForm from "taskpane/components/loginForm";
import { useLocation } from "react-router-dom";
import "../styles/loginPage.css";

interface ILocationState {
  email: string;
  errorMessage: string;
}

const LoginPage: React.FC = (): React.JSX.Element => {
  const locationState = useLocation<ILocationState>().state;
  const email = locationState?.email;
  const errorMessage = locationState?.errorMessage;

  return (
    <div className="loginPage" data-testid="loginPage">
      <LoginForm email={email} errorMessage={errorMessage} />
    </div>
  );
};

export default LoginPage;
